import React, { Component, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';

const Home = React.lazy(() => import('./components/Home'));
const Login = React.lazy(() => import('./components/Login'));
const Posts = React.lazy(() => import('./components/Posts'));
const ModuleDesginer = React.lazy(() => import('./components/ModuleDesginer'));
const Post = React.lazy(() => import('./components/Post'));
const Comments = React.lazy(() => import('./components/Comments'));
const Comment = React.lazy(() => import('./components/Comment'));
const NewsLetters = React.lazy(() => import('./components/NewsLetters'));
const NewsLetter = React.lazy(() => import('./components/NewsLetter'));
const Users = React.lazy(() => import('./components/Users'));
const User = React.lazy(() => import('./components/User'));
const Customers = React.lazy(() => import('./components/Customers'));
const Customer = React.lazy(() => import('./components/Customer'));
const FM = React.lazy(() => import('./components/FM'));
const Profile = React.lazy(() => import('./components/Profile'));
const Settings = React.lazy(() => import('./components/Settings'));
const PostAttributes = React.lazy(() => import('./components/PostAttributes'));
const PostAttribute = React.lazy(() => import('./components/PostAttribute'));
const Stores = React.lazy(() => import('./components/Stores'));
const Store = React.lazy(() => import('./components/Store'));
const UserGroups = React.lazy(() => import('./components/UserGroups'));
const OrdersList = React.lazy(() => import('./components/OrdersList'));
const Order = React.lazy(() => import('./components/Order'));
const FastUpdate = React.lazy(() => import('./components/FastUpdate'));

const InsuranceRate = React.lazy(() => import('./components/shop/InsuranceRate'));
const InsuranceRates = React.lazy(() => import('./components/shop/InsuranceRates'));
const ShipmentMethod = React.lazy(() => import('./components/shop/ShipmentMethod'));
const ShipmentMethods = React.lazy(() => import('./components/shop/ShipmentMethods'));
const ShippingZone = React.lazy(() => import('./components/shop/ShippingZone'));
const ShippingZones = React.lazy(() => import('./components/shop/ShippingZones'));

class App extends Component {
    constructor(props) {
        super(props);
    }

    getDefaultGuid() {
        return '00000000-0000-0000-0000-000000000000';
    }

    render() {
        return <Layout>
            <Suspense fallback={<div></div>}>
                <Routes basename="/profile/">
                    <Route path="/dashboard" element={<Home />}></Route>
                    <Route path="/login/" element={<Login />}></Route>

                    <Route path="/moduledesginer/" element={<ModuleDesginer />}></Route>

                    <Route path="/comments/" element={<Comments />}></Route>
                    <Route path='/comments/edit/:id/' element={<Comment id={1} />} />

                    <Route path="/shop/fast/update/" element={<FastUpdate />}></Route>

                    <Route path="/shop/orders/" element={<OrdersList />}></Route>
                    <Route path="/shop/orders/new/" element={<Order id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/orders/edit/:id/' element={<Order id={1} />} />
                    
                    <Route path="/shop/stores/" element={<Stores Type={1} />}></Route>
                    <Route path="/shop/stores/new/" element={<Store Type={1} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/stores/edit/:id/' element={<Store Type={1} id={1} />} />
                    
                    <Route path="/news/" element={<Posts Type={1} />}></Route>
                    <Route path="/news/new/" element={<Post Type={1} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/news/edit/:id/' element={<Post Type={1} id={1} />} />

                    <Route path="/blogs/" element={<Posts Type={2} />}></Route>
                    <Route path="/blogs/new/" element={<Post Type={2} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/blogs/edit/:id/' element={<Post Type={2} id={1} />} />

                    <Route path="/pages/" element={<Posts Type={3} />}></Route>
                    <Route path="/pages/new/" element={<Post Type={3} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/pages/edit/:id/' element={<Post Type={3} id={1} />} />

                    <Route path="/tags/" element={<Posts Type={4} />}></Route>
                    <Route path="/tags/new/" element={<Post Type={4} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/tags/edit/:id/' element={<Post Type={4} id={1} />} />

                    <Route path="/blogcategories/" element={<Posts Type={5} />}></Route>
                    <Route path="/blogcategories/new/" element={<Post Type={5} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/blogcategories/edit/:id/' element={<Post Type={5} id={1} />} />

                    <Route path="/newscategories/" element={<Posts Type={6} />}></Route>
                    <Route path="/newscategories/new/" element={<Post Type={6} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/newscategories/edit/:id/' element={<Post Type={6} id={1} />} />

                    <Route path="/menus/" element={<Posts Type={8} />}></Route>
                    <Route path="/menus/new/" element={<Post Type={8} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/menus/edit/:id/' element={<Post Type={8} id={1} />} />

                    <Route path="/ads/" element={<Posts Type={9} />}></Route>
                    <Route path="/ads/new/" element={<Post Type={9} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/ads/edit/:id/' element={<Post Type={9} id={1} />} />

                    <Route path="/products/" element={<Posts Type={10} />}></Route>
                    <Route path="/products/new/" element={<Post Type={10} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/products/edit/:id/' element={<Post Type={10} id={1} />} />

                    <Route path="/productcategories/" element={<Posts Type={11} />}></Route>
                    <Route path="/productcategories/new/" element={<Post Type={11} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/productcategories/edit/:id/' element={<Post Type={11} id={1} />} />

                    <Route path="/services/" element={<Posts Type={12} />}></Route>
                    <Route path="/services/new/" element={<Post Type={12} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/services/edit/:id/' element={<Post Type={12} id={1} />} />

                    <Route path="/servicecategories/" element={<Posts Type={13} />}></Route>
                    <Route path="/servicecategories/new/" element={<Post Type={13} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/servicecategories/edit/:id/' element={<Post Type={13} id={1} />} />

                    <Route path="/sliders/" element={<Posts Type={14} />}></Route>
                    <Route path="/sliders/new/" element={<Post Type={14} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/sliders/edit/:id/' element={<Post Type={14} id={1} />} />

                    <Route path="/shop/categories/" element={<Posts Type={15} />}></Route>
                    <Route path="/shop/categories/new/" element={<Post Type={15} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/categories/edit/:id/' element={<Post Type={15} id={1} />} />

                    <Route path="/shop/products/" element={<Posts Type={16} />}></Route>
                    <Route path="/shop/products/new/" element={<Post Type={16} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/products/edit/:id/' element={<Post Type={16} id={1} />} />

                    <Route path="/shop/tags/" element={<Posts Type={17} />}></Route>
                    <Route path="/shop/tags/new/" element={<Post Type={17} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/tags/edit/:id/' element={<Post Type={17} id={1} />} />

                    <Route path="/redirects/" element={<Posts Type={18} />}></Route>
                    <Route path="/redirects/new/" element={<Post Type={18} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/redirects/edit/:id/' element={<Post Type={18} id={1} />} />

                    <Route path="/shop/brands/" element={<Posts Type={19} />}></Route>
                    <Route path="/shop/brands/new/" element={<Post Type={19} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/brands/edit/:id/' element={<Post Type={19} id={1} />} />

                    <Route path="/shop/attributes/" element={<PostAttributes />}></Route>
                    <Route path="/shop/attributes/new/" element={<PostAttribute id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/attributes/edit/:id/' element={<PostAttribute id={1} />} />
                    
                    <Route path="/magazines/" element={<Posts Type={21} />}></Route>
                    <Route path="/magazines/new/" element={<Post Type={21} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/magazines/edit/:id/' element={<Post Type={21} id={1} />} />

                    <Route path="/shop/stores/categories/" element={<Posts Type={23} />}></Route>
                    <Route path="/shop/stores/categories/new/" element={<Post Type={23} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/stores/categories/edit/:id/' element={<Post Type={23} id={1} />} />

                    <Route path="/templates/" element={<Posts Type={25} />}></Route>
                    <Route path="/templates/new/" element={<Post Type={25} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/templates/edit/:id/' element={<Post Type={25} id={1} />} />

                    <Route path="/forms/" element={<Posts Type={24} />}></Route>
                    <Route path="/forms/new/" element={<Post Type={24} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/forms/edit/:id/' element={<Post Type={24} id={1} />} />

                    <Route path="/shop/guarantees/" element={<Posts Type={26} />}></Route>
                    <Route path="/shop/guarantees/new/" element={<Post Type={26} id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/guarantees/edit/:id/' element={<Post Type={26} id={1} />} />

                    <Route path="/shop/shipmentmethods/" element={<ShipmentMethods />}></Route>
                    <Route path="/shop/shipmentmethods/new/" element={<ShipmentMethod id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/shipmentmethods/edit/:id/' element={<ShipmentMethod id={1} />} />

                    <Route path="/shop/insurancerates/" element={<InsuranceRates />}></Route>
                    <Route path="/shop/insurancerates/new/" element={<InsuranceRate id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/insurancerates/edit/:id/' element={<InsuranceRate id={1} />} />

                    <Route path="/shop/shippingzones/" element={<ShippingZones />}></Route>
                    <Route path="/shop/shippingzones/new/" element={<ShippingZone id={this.getDefaultGuid()} />}></Route>
                    <Route path='/shop/shippingzones/edit/:id/' element={<ShippingZone id={1} />} />

                    <Route path="/users/" element={<Users />}></Route>
                    <Route path="/users/new/" element={<User id={this.getDefaultGuid()} />}></Route>
                    <Route path='/users/edit/:id/' element={<User id={1} />} />

                    <Route path="/customers/" element={<Customers />}></Route>
                    <Route path="/customers/new/" element={<Customer id={this.getDefaultGuid()} />}></Route>
                    <Route path='/customers/edit/:id/' element={<Customer id={1} />} />

                    <Route path="/newsletters/" element={<NewsLetters />}></Route>
                    <Route path="/newsletters/new/" element={<NewsLetter id={this.getDefaultGuid()} />}></Route>
                    <Route path='/newsletters/edit/:id/' element={<NewsLetter id={1} />} />

                    <Route path='/fm' element={<FM />} />

                    <Route path='/profile' element={<Profile />} />
                    <Route path='/settings' element={<Settings />} />

                    <Route path='/usergroups' element={<UserGroups />} />

                    <Route path="*" element={<Navigate to="/dashboard/" />}></Route>
                </Routes>
            </Suspense>
        </Layout>
    }
}

export default App;
